import { environment } from '../../../environments/environment';

/** Kurum paneli uçlarının kök yolu. Bu yola giden isteğe orgTokenInterceptor org web token'ını takar. */
export const ORG_API_PREFIX = '/v2/Org/';

/** Sözleşme yolu → tam adres: `orgUrl('/Org/Settings')` = `<api>/v2/Org/Settings`. */
export function orgUrl(path: string): string {
  return `${environment.kartexApiUrl}/v2${path.startsWith('/') ? path : '/' + path}`;
}

/**
 * İstek adresi kurum paneli ucu mu: `<api>/v2/Org/...` ya da göreli `/v2/Org/...`.
 * Harf duyarsızdır (ASP.NET yolları duyarsız eşler; adres farklı yazılsa da org token'ı takılır).
 */
export function isOrgApiUrl(url: string): boolean {
  const u = url.toLowerCase();
  const prefix = ORG_API_PREFIX.toLowerCase();
  return u.startsWith(`${environment.kartexApiUrl}${ORG_API_PREFIX}`.toLowerCase()) || u.startsWith(prefix);
}
